<div class="images-uploader">
    <div class="upload-arena g-just-flex gap-12" (click)="openPickerForAdd($event)">
        <div class="rounded-icon-wrapper"><mat-icon>image</mat-icon></div>
        <div class="g-title-subtitle-under-without-h1 g-title-subtitle-on-white">
            <div class="g-title">{{ uploadLabel }}</div>
            <div class="g-subtitle subtitle-text-color-2">
                Click here to upload images
                @if (allowedFilesCategoryLabel) { in {{ allowedFilesCategoryLabel }} }
            </div>
        </div>
    </div>

    @if (images?.length && !isReading) {
    <div class="actions">
        <button mat-stroked-button (click)="openPickerForAdd($event)">Add more images</button>
    </div>
    }

    <input #fileInput type="file" accept="image/*" style="display: none;" (change)="onFileInputChanged($event)" />

    @if (isReading) {
    <div class="reading-row g-just-flex gap-12">
        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
        <div class="subtitle-text-color-2">Reading image…</div>
        <span class="spacer"></span>
        <button mat-stroked-button color="warn" (click)="cancelRead($event)">Cancel</button>
    </div>
    }

    @if (images?.length) {
    <div class="images-grid">
        @for (img of images; track img.id) {
        <mat-card class="img-card">
            <img class="thumb" [src]="img.dataUrl || img.fileLink" [alt]="img.fileName" />

            <div class="meta">
                <div class="meta-row">
                    <mat-checkbox [checked]="img.selected" (change)="toggleSelected(img.id, $event.checked, $event)">
                        Select
                    </mat-checkbox>
                    <span class="spacer"></span>
                    <button mat-icon-button (click)="openPickerForReplace(img.id, $event)" aria-label="Replace image">
                        <mat-icon>sync</mat-icon>
                    </button>
                    <button *ngIf="img.fileLink" mat-icon-button color="primary" (click)="openInNewTab(img.fileLink, $event)"
                        aria-label="Open image in new tab">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="removeImage(img.id, $event)" aria-label="Remove image">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <div class="name" title="{{ img.fileName }}">{{ img.fileName }}</div>
                <div class="sub subtitle-text-color-2">{{ img.size | bytetounit }}</div>
            </div>
        </mat-card>
        }
    </div>
    } @else {
    <div class="empty subtitle-text-color-2">No images added yet.</div>
    }
</div>